import GetEventDetail from "./GetEvent.jsx/GetEventDetail"
import { FormProvider } from './FormContext'
import { Navigate, useLocation } from "react-router-dom";

function GetDetailEmail() {
    const location = useLocation();
    const urlSplit = location.pathname.split("/");
    var eventId = urlSplit[2];
    if (urlSplit.length > 3) {
        eventId = eventId + "/" + urlSplit[3];
    }
    var role = localStorage.getItem('role');
    switch (role) {
        case 'Visit Requester':
        case 'Requester':
          return (
            <FormProvider>
              <GetEventDetail  />
            </FormProvider>
          )
        case 'MLTUser':
        case 'MLTCoordinator':
          return (
            <div>
              <Navigate to={`/GetDetailEventMlt/${eventId}`} replace />
            </div>          
          )
        case 'Admin':
          return (
            <div>
              <Navigate to={`/GetDetailAdmin/${eventId}`} replace />
            </div>          
          )
        case 'Family':
        case 'FamilyCoordinator':
          return (
            <div>
              <Navigate to={`/getDetailMarsComplete/${eventId}`} replace />
            </div>          
          )
        default:
          return (
            <div>
              <Navigate to="/" replace />
            </div>          
          )
    }
}

export default GetDetailEmail;